import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import heroBg from "@/assets/hero-bg.webp";

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img src={heroBg} alt="" className="w-full h-full object-cover" width={1280} height={720} fetchPriority="high" />
        <div className="absolute inset-0 bg-foreground/55" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-3xl">
        <p className="font-sans text-xs uppercase tracking-[0.35em] text-white/70 mb-4 animate-fade-in">
          Psychotherapie und Supervision
        </p>
        <h1 className="font-serif text-4xl md:text-6xl font-bold text-white mb-4 animate-fade-in-delay">
          Praxis Sorgenfrey
        </h1>
        <p className="font-serif text-xl italic text-white/70 mt-6 mb-10 animate-fade-in-delay-2">
          „Ein sicherer Raum für Ihre seelische Gesundheit."
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-delay-2">
          <Button variant="hero" size="lg" asChild>
            <Link to="/kontakt">Kontakt aufnehmen</Link>
          </Button>
          <Button variant="warmOutline" size="lg" asChild className="border-white/60 text-white hover:bg-white/10 hover:text-white">
            <Link to="/ueber-uns">Über uns</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
